module.exports = __webpack_public_path__ + "static/media/merriweather-italic-webfont.9830783a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-italic-webfont.woff2
// module id = 291
// module chunks = 0